module.exports = __webpack_public_path__ + "img/410.9e72b90b.jpg";